/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, {
    useMemo,
    useState,
  } from "react";
  import { useNavigate } from "react-router-dom";
  import {
    AlertComponent,
  } from "../../../common/components";
  import { useSetLoading } from "../../../common/hooks/appearance";
  import { routes } from "../../..//constants/routes";
  import CreateLeadCaptureForm from "../view-surveys/create-lead-capture-form/create-lead-capture-form";
import { useResourcePermissions } from "../../../common/hooks/resource-permissions";
import MODULES from "../../../constants/modules";
  
  const CreateSurveys = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string | null>(null);
    const [alertType, setAlertType] = useState<
      "error" | "success" | "info" | "warning"
    >("info");
    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [isViewMode, setIsViewMode] = useState<any>(false);
    const [createLeadCaptureInitialValues, setCreateLeadCaptureInitialValues] =
      useState<any>(null);
    const navigate = useNavigate();
    const { canRead, canWrite, canDelete } = useResourcePermissions(
        MODULES.CREATE_SURVEYS
      );
  
    const showLoading = useMemo(() => loading, [loading]);
    useSetLoading(showLoading);
  
    return (
      <>
          <CreateLeadCaptureForm
            setCreateLeadCaptureInitialValues={setCreateLeadCaptureInitialValues}
            createLeadCaptureInitialValues={createLeadCaptureInitialValues}
            setIsShowCreateLeadSection={(value: boolean) =>{}}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            setLoading={setLoading}
            fetchLeadCaptureForms={(isShareOrSav: any) => {
                if (!isShareOrSav) {
                    navigate(routes.VIEWSURVEY);
                }
            }}
            isViewMode={isViewMode}
            setIsViewMode={setIsViewMode}
            isFromNewSurvey={true}
            canWrite={canWrite}
          />
        <AlertComponent
          message={alertMessage}
          type={alertType ?? "info"}
          open={alertOpen}
          onClose={() => setAlertOpen(false)}
        />
      </>
    );
  };
  
  export default CreateSurveys;
  